import { render, staticRenderFns } from "./logsPage.vue?vue&type=template&id=472d0b89&scoped=true"
import script from "./logsPage.vue?vue&type=script&lang=js"
export * from "./logsPage.vue?vue&type=script&lang=js"
import style0 from "./logsPage.vue?vue&type=style&index=0&id=472d0b89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472d0b89",
  null
  
)

export default component.exports